<template>
  <v-card class="elevation-0 details-layout__content">
    <v-card-title>
        <v-layout row wrap class="payments-layout__menu py-1">
          <v-flex sm10>
            <span class="menu-item">
              <router-link :to="{ name: 'paymentsWeekly' }">
                Weekly
              </router-link>
            </span>
            <span class="menu-item">
              <router-link :to="{ name: 'paymentsFilter' }">
                Filter
              </router-link>
            </span>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
    </v-card-title>
    <v-card-text class="py-0">
      <v-container grid-list-md px-0>
        <v-layout row wrap>
          <v-flex xs3>
            <v-layout row>
              <v-flex align-self-center shrink>
                <v-icon large>calendar_today</v-icon>
              </v-flex>
              <v-flex grow>
                <v-menu
                  v-model="displayFilterStartDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="filterStartDate"
                      label="Select Start Date"
                      readonly
                      :rule="dateRules"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="startDate"
                    no-title
                    @input="displayFilterStartDate = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs3>
            <v-layout row>
              <v-flex align-self-center shrink>
                <v-icon large>calendar_today</v-icon>
              </v-flex>
              <v-flex grow>
                <v-menu
                  v-model="displayFilterEndDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="filterEndDate"
                      label="Select End Date"
                      readonly
                      :rule="dateRules"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="endDate"
                    no-title
                    @input="displayFilterEndDate = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs3>
            <v-btn color="primary" @click.stop="redirectToFilteredUrl()">
              Submit
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <div>
              <v-data-table
                v-model="selectedPayments"
                :headers="headers"
                :items="payments"
                select-all
                item-key="id"
                :rows-per-page-items="rowsPerPage"
                class="table--fixed"
              >
                <template v-slot:headers="props">
                  <tr>
                    <th style="width: 5%">
                      <v-checkbox
                        :input-value="props.all"
                        :indeterminate="props.indeterminate"
                        primary
                        hide-details
                        @click.stop="toggleAll"
                      ></v-checkbox>
                    </th>
                    <th
                      v-for="header in props.headers"
                      :key="header.text"
                      class="text-xs-left"
                      :style="{ width: header.width }"
                    >
                      <span class="font-weight-bold">{{ header.text }}</span>
                    </th>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <tr @click="showPayment(props.item, $event)">
                    <td>
                      <v-checkbox
                        :disabled="!props.item.id"
                        :input-value="props.selected"
                        primary
                        hide-details
                        @change="props.selected = !props.selected"
                      ></v-checkbox>
                    </td>
                    <td>
                      {{
                      (props.item.unit ? [props.item.unit, props.item.num].join('/') : props.item.num) +
                          ' ' + props.item.street +
                          ', ' + props.item.suburb
                      }}
                    </td>
                    <td>{{ props.item.paydue_time | moment('D/MM/YYYY') }}</td>
                    <td>{{ props.item.paystart_time | moment('D/MM/YYYY') }}</td>
                    <td>{{ props.item.payend_time | moment('D/MM/YYYY') }}</td>
                    <td>{{ '$' + props.item.pay_amount }}</td>
                    <td :style="{color: props.item.color}">{{props.item.display_amount}}</td>
                    <td v-if="+props.item.state === 1">
                      <v-tooltip left>
                        <template v-slot:activator="{ on }">
                          <v-icon color="success" v-on="on">done_outline</v-icon>
                        </template>
                        <span>Processed</span>
                      </v-tooltip>
                    </td>
                    <td v-else>
                      <v-tooltip left>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">error</v-icon>
                        </template>
                        <span>Unprocessed</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions } from 'vuex'
import paymentHelper from '@/helpers/payment'
import alertHelper from '@/helpers/alert'
import moment from 'moment'

export default {
  name: 'PaymentsFilter',
  data() {
    return {
      headers: [
        {
          text: 'Address',
          align: 'left',
          sortable: false,
          value: 'address',
          width: '30%'
        },
        {
          text: 'Pay Due Date',
          align: 'left',
          sortable: false,
          value: 'paydue_time',
          width: '10%'
        },
        {
          text: 'Pay From Date',
          align: 'left',
          sortable: false,
          value: 'paystart_time',
          width: '10%'
        },
        {
          text: 'Pay To Date',
          align: 'left',
          sortable: false,
          value: 'payend_time',
          width: '10%'
        },
        { text: 'Rent ($)',
          align: 'left',
          sortable: false,
          value: 'pay_amount',
          width: '10%'
        },
        { text: 'Payment ($)',
          align: 'left',
          sortable: false,
          value: 'total_amount',
          width: '10%'
        },
        { text: 'Status',
          align: 'left',
          sortable: false,
          value: 'status',
          width: '10%'
        },
      ],
      selectedPayments: [],
      selectedPayment: {},
      showSummary: false,
      rowsPerPage: [20, 50, 100, {text:"$vuetify.dataIterator.rowsPerPageAll", value: 20}],
      startDate: '',
      endDate: '',
      displayFilterStartDate: false,
      displayFilterEndDate: false,
      dateRules: [
        (v) => !!v || 'Date is required',
        (v) =>
          /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}:$/.test(v) ||
          'Date must be valid',
      ],
    }
  },
  computed: {
    payments() {
      const payments = this.$store.getters['Payments/getPayments']

      if (payments.length > 0) {
        payments.map(i => {
          if (+i.state === 0) {
            i.display_amount = ''
          } else {
            i.display_amount = `$${i.total_amount.toFixed(2)}`
            i.color= (i.total_amount >= 0)? 'black': 'red'
          }
          return i
        })
      }

      return payments
    },
    filterStartDate() {
      return this.formatDate(this.startDate)
    },
    filterEndDate() {
      return this.formatDate(this.endDate)
    }
  },
  watch: {
    $route(to, from) {
      if (typeof to.query.start !== 'undefined' && typeof to.query.end !== 'undefined') {
        this.getFilteredData()
      }
    }
  },
  mounted() {
    /*
      TODO: This is not a good solution
      Due to time restrictions had to do it this way
    */
    this.$root.$on('xp-process-payments', () => {
      this.processPayments()
    })

    this.$root.$on('xp-generate-bank-file', () => {
      this.downloadBankFile(this.selectedPayments)
    })

    this.startDate = this.$route.query.start
    this.endDate = this.$route.query.end
    this.getFilteredData()
  },
  deactivated() {
    this.selectedPayment = {}
    this.showSummary = false
  },
  methods: {
    ...mapActions({
      updateMany: 'Payments/bulkUpdate',
      getPayments: 'Payments/getPayments',
      downloadBankFile: 'Payments/downloadBankFile',
      getLastBalance: 'HouseList/Payments/getLastBalance',
    }),
    toggleAll() {
      if (this.selectedPayments.length) {
        this.selectedPayments = []
      } else {
        this.selectedPayments = this.payments.slice()
      }
    },
    async processPayments() {
      const payments = JSON.parse(JSON.stringify(this.selectedPayments))
      for (const payment of payments) {
        payment.balance = await this.getLastBalance({id: payment.id})
      }

      // Unprocessed to processed
      let paymentsToUpdate = []
      payments.forEach((payment) => {
        if (+payment.state === 0) {
          payment.state = 1
          if (payment.mf_gst_status === null) {
            payment.mf_gst_status = this.managerGstStatus.value
          }
          payment.manager_fee_real = payment.manager_fee
          payment.manager_fee_gst = paymentHelper.calculateManagerFeeGst(
            payment
          )
          let feeTotal = 0;
          let feeTotalGST = 0;
          const fees = payment.fee.filter(f => f.state === 0)
          if (fees.length > 0) {
            fees.forEach((fee) => {
              feeTotal += Number(fee.fee_real)
              feeTotalGST += Number(fee.fee_gst)
              fee.state = 1
              fee.payment_id = payment.id;
            })
          }

          if (!payment.pay_time) {
            payment.pay_time = moment().format('YYYY-MM-DD')
          }
          payment.total_amount = (payment.pay_amount - payment.manager_fee_real - payment.manager_fee_gst - feeTotal - feeTotalGST + payment.balance).toFixed(2)

          paymentsToUpdate.push(payment)
        }
      })

      if (paymentsToUpdate.length > 0) {
        this.updateMany(paymentsToUpdate)
      } else {
        alertHelper.error(
          'No action required. Payments are already processed.'
        )
      }

      this.selectedPayments = []
    },
    showPayment(payment, event) {
      if (payment.id && event.target.tagName.toLowerCase() === 'td') {
        this.$router.push({ path: `/payments/${payment.id}` })
      }
    },
    formatDate: function(date) {
      return date ? moment(date).format('DD MMMM YYYY') : null
    },
    redirectToFilteredUrl: function() {
      if (this.startDate !== '' && this.endDate !== '') {
        this.$router.push({
          path: `/payments/filter?start=${this.startDate}&end=${this.endDate}`
        })
      } else {
        alertHelper.error('Please select a start and end date')
      }
    },
    getFilteredData() {
      this.$store.dispatch('Payments/clear')

      if (typeof this.$route.query.start !== 'undefined' && typeof this.$route.query.end !== 'undefined') {
        this.$store.dispatch(
          'Payments/getPayments',
          this.getPaymentParameters(this.$route.query)
        )
      }
    },
    getPaymentParameters(query) {
      let result = { params: {} }

      result.params.paydue_time_begin = query.start
      result.params.paydue_time_end = query.end
      result.params.state = "0,1"

      return result
    },
    setDates(query) {
      this.startDate = query.start
      this.endDate = query.end
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~vuetify/src/stylus/settings/_colors';

.table--fixed >>> .v-table {
  table-layout: fixed !important;
}
.payments-layout__menu {
  border-bottom: 1px solid $grey.lighten-2;
}


</style>
